import { apiClient } from '../lib/apiClient';

/**
 * CTV-570 (radius-min v2) — mirror of `MinRadiusResponse` from
 * `selfservice-api/src/modules/inventory/dto/min-radius.dto.ts`.
 */
export interface MinRadiusResponse {
  minFeasibleMiles: number | null;
  totalMs?: number;
  /** CTV-678: per-stage timings, populated with `includeDiagnostic`. */
  stages?: {
    resolveProductMs: number;
    renderRateMs: number;
    fanoutAMs: number;
    fanoutBMs: number;
    algorithmMs: number;
  };
}

export interface MinRadiusInput {
  productId: string;
  budget: number;
  startDate: string;
  endDate: string;
  paymentPlan: 'upfront' | 'monthly';
  centerLat: number;
  centerLng: number;
  includeDiagnostic?: boolean;
}

export async function checkMinFeasibleRadius(
  input: MinRadiusInput,
  signal?: AbortSignal,
): Promise<MinRadiusResponse> {
  return apiClient.post<MinRadiusResponse>(
    '/inventory/min-feasible-radius',
    input,
    { anonymous: true, signal },
  );
}
